import { Divider, Grid, useMediaQuery, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import genericPage from '../../assets/images/genericPage.png';
import { StyledDescription } from '../../components/StyledDescription';
import { StyledTitle } from '../../components/StyledTitle';
import { useLoaderContext } from '../../contexts/LoaderContext';
import { _ } from '../../shared/utils';

export const ConfirmedPromoPage: React.FC = () => {

    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up(970));
    const setLoader = useLoaderContext();

    React.useEffect(() => {
        setLoader(false);
        //_.redirectWithDelay();
    }, []);

    return (
        <Grid height="100%" container>
            {matches && (
                <Grid sm={5} sx={{ backgroundColor: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }} item>
                    <img src={genericPage} width="450" alt='genericPage' />
                </Grid>
            )}
            <Grid
                sm={matches ? 7 : 12}
                sx={{
                    background: "#f2f2f2"
                }}
                item
            >
                <Box
                    display="flex"
                    justifyContent="center"
                    flexDirection="column"
                    gap={2}
                    overflow="auto"
                    height="100%"
                >
                    <StyledTitle>
                        Grazie per il tuo ordine! Il servizio sar&agrave; disponibile nel tuo gestionale nei prossimi giorni
                    </StyledTitle>
                    <Divider orientation="horizontal" />
                    <StyledDescription>
                        A breve riceverai una PEC con:
                        <br />
                        <ul>
                            <li>la conferma del buon esito dell&#39;acquisto</li>
                            <li>il riepilogo dei termini e condizioni contrattuali</li>
                            <li>l&#39;informativa sul trattamento dei tuoi dati personali</li>
                        </ul>
                        Buona giornata!
                    </StyledDescription>
                </Box>
            </Grid>
        </Grid>
    );
};
